<template>
  <v-btn v-bind="headerButtonSize" :href="url" target="_blank" color="vor">
    <v-img :src="require('@/assets/vor-icon-36.png')" />
  </v-btn>
</template>

<script>
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';

export default {
  name: 'VorButton',
  mixins: [ResponsiveSizeHelperMixin],
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>
